import React from "react"

import {
	Divider,
	List,
	ListItemButton,
	Typography,
} from "@mui/material"

import {
	Trans,
} from "@lingui/macro"

import { ErrorResponse, RestResponse } from "@sinossi/mates-react-library"
import { Visit, SessionResponse, UpdateVisitRequest } from "models"
import { VisitService } from "../../../services/visit.service"
import withUseRouter, { UseRouterParams } from "../../../services/router"
import { MatesComponent, MatesComponentState } from "../../mates-component"
import { VisitDetail, ScheduleVisitModal } from "../../visit"

interface DashboardVisitsListProps extends UseRouterParams {
	visits: Visit[]
	sessionData: SessionResponse
	refresh: () => void
}

interface DashboardVisitsListState extends MatesComponentState {
	selectedVisit: Visit | null
	openEditModal: boolean
}

class DashboardVisitsList extends React.Component<DashboardVisitsListProps, DashboardVisitsListState> {
	private readonly matesComponent: MatesComponent<DashboardVisitsListProps, DashboardVisitsListState> = new MatesComponent(this)

	constructor(props: DashboardVisitsListProps) {
		super(props);
		this.state = {
			...this.matesComponent.setupState(),
			selectedVisit: null,
			openEditModal: false
		}
	}

	private openEditModal = (visit: Visit) => {
		this.setState({
			selectedVisit: visit,
			openEditModal: true
		})
	}

	private closeEditModal = () => {
		this.setState({
			selectedVisit: null,
			openEditModal: false
		})
	}

	private handleUpdateVisit = (updateData: UpdateVisitRequest) => {
		if (!this.state.selectedVisit) {
			return
		}

		VisitService.updateVisit(
			this.state.selectedVisit.id,
			updateData,
			this.handleUpdateVisitCallback,
			this.matesComponent.onException
		)
	}

	private handleUpdateVisitCallback = (response: RestResponse<any, ErrorResponse>) => {
		if (response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.closeEditModal()
		this.props.refresh()
	}

	private scrollToLastElem = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		const htmlElem = (event.target as HTMLElement).parentElement as HTMLElement
		const listElem = (htmlElem.parentElement as HTMLElement).previousElementSibling as HTMLElement
		const listItemsElem = Array.from(listElem.children).filter((elem) => elem.classList.contains("MuiButtonBase-root"))
		const targetListItem = listItemsElem[listItemsElem.length - 1] as HTMLElement
		targetListItem.scrollIntoView({
			block: "end",
			inline: "nearest",
			behavior: "smooth"
		})
	}

	render() {
		const { visits } = this.props
		const visitsArray = visits || []

		return (
			<>
				{visitsArray.length === 0 &&
					<Typography sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
						<Trans id="dashboard.no-visits-to-do">
							Nessun sopralluogo da effettuare.
						</Trans>
					</Typography>
				}

				<List sx={{ width: "100%", height: `100%`, overflow: "auto", mt: 4 }}>
					{visitsArray.map((visit: Visit) => (
						<>
							<ListItemButton key={visit.id} disableRipple disableTouchRipple>
								<VisitDetail
									data={visit}
									sessionData={this.props.sessionData}
									onEdit={() => this.openEditModal(visit)}
								/>
							</ListItemButton>
							<Divider />
						</>
					))}
				</List>

				{this.state.openEditModal && this.state.selectedVisit && (
					<ScheduleVisitModal
						open={this.state.openEditModal}
						visit={this.state.selectedVisit}
						onClose={this.closeEditModal}
						onSubmit={this.handleUpdateVisit}
					/>
				)}
			</>
		)
	}
}

export default withUseRouter(DashboardVisitsList)
